module.exports = __webpack_public_path__ + "static/img/idtype_app.77c2be1e.png";